import z from "zod";

import { ZodSchemas } from "./zod-schemas.class";

export const checkBalanceFormFieldsSchema = ZodSchemas.all.pick({
  CardNumber: !0,
  CardPin: !0,
});

export type CheckBalanceFormFields = z.infer<typeof checkBalanceFormFieldsSchema>;

export const checkBalanceRequestSchema = ZodSchemas.all
  .partial({
    OrderID: !0,
  })
  .pick({
    CardPin: !0,
    CardNumber: !0,
    ConfigurationID: !0,
    OrderID: !0,
    OrganizationUnitID: !0,
  });

export type CheckBalanceRequest = z.infer<typeof checkBalanceRequestSchema>;

export interface CheckBalanceResponse extends EVA.Core.CardBalanceCheckResponse {
  Activation?: number;
  Expiry?: number;
}
